class ValueDisplay {
    constructor() {
        this._init()
    }
    _init() {
        const datasToDisplay= ['data-value', 'data-result', 'data-value-display']
        const currency = document.querySelector('[data-currency-symbol]')
        if(currency) {
            this.currency = currency.getAttribute('data-currency-symbol')
        }
        this.els = []
        datasToDisplay.forEach(data => {
            const els = Array.from(document.querySelectorAll('[' + data + ']'))
            els.forEach(el => {
                el.dataType = data
                el.manager = this
            })
            this.els = this.els.concat(els)
        })
        this.onValueAction()
        this.setValuesActions()
    }
    onValueAction() {
        this.getValues()
        this.updateDisplays()
    }
    setValuesActions() {
        this.elActions = document.querySelectorAll('[data-value-action]')
        this.elActions.forEach(el => el.addEventListener('click', () => this.onValueAction()))
    }
    getValues() {
        this.els.forEach(el => {
            el.value = el.getAttribute(el.dataType)
        })
    }
    updateDisplays() {
        this.els.forEach(el => {
            if(el.value) {
                const newtext = this.getFormatted(el.value)
                el.innerText = newtext
            }
        })
    }
    getFormatted(value, type = 'price') {
        switch(type) {
            case 'price':
                let s = parseFloat(value).toFixed(2)
                s = s.split('.')
                let formatted = this.currency + s[0] + "," + s[1] + " "
                return formatted
            default:
                throw "Case not supported"
        }
    }
}

export default ValueDisplay